export const advertasing = () => {
    jQuery(document).ready(function ($) {

        function isMobile() {
            return window.matchMedia('(max-width: 768px)').matches; 
        }

        function resetBlock(fatherBlock) {
            let advertiseName = fatherBlock.find('.advertise-block__name');
            let blockContents = fatherBlock.find('.block-content');
            let changer = fatherBlock.find('.advertise-block__changer');
            let centralImg = fatherBlock.find('.advertise-block__central-img');

            changer.html('');
            centralImg.html('');
            advertiseName.removeClass('advertise-block__name_active');
            blockContents.removeClass('block-content_active');
        }

        function updateContent(currentContent, changer, centralImg) {
            let currentDescription = currentContent.find('.advertise-block__content-description').html();
            let currentLink = currentContent.find('.advertise-block__content-link').html();
            let currentImage = currentContent.find('.advertise-block__content-image').html();

            changer.append(currentDescription);
            changer.append(currentLink);
            centralImg.append(currentImage);
        }

        function handleClick(currentItem, fatherBlock, isInitial = false) {
            let clicked = currentItem.data('clicked');
            let changer = fatherBlock.find('.advertise-block__changer');
            let centralImg = fatherBlock.find('.advertise-block__central-img');
            let currentContent = currentItem.next('.advertise-block__content');

            if (!isInitial && currentItem.hasClass('advertise-block__name_active') && isMobile()) {
                resetBlock(fatherBlock);  
            } else {
                resetBlock(fatherBlock);
                currentItem.addClass('advertise-block__name_active');
                currentContent.addClass('block-content_active');
                updateContent(currentContent, changer, centralImg);
            }

            currentItem.data('clicked', !clicked);
        }

        
        $('.advertise-block').each(function () {
            let fatherBlock = $(this);

            fatherBlock.find('.advertise-block__name').on("click", function () {
                handleClick($(this), fatherBlock);
            });

            
            let firstItem = fatherBlock.find('.advertise-block__name').first();
            handleClick(firstItem, fatherBlock, true); 
        });
    });
}
